"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _AssignmentCard = _interopRequireDefault(require("../../components/Card/AssignmentCard.js"));
var _HiddenBlock = _interopRequireDefault(require("../../components/HiddenBlock"));
var _admin = require("../../reducers/admin.js");
var _admin2 = require("../../selectors/admin.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ProjectDetail = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectDetail, _React$Component);
  var _super = _createSuper(ProjectDetail);
  function ProjectDetail() {
    _classCallCheck(this, ProjectDetail);
    return _super.apply(this, arguments);
  }
  _createClass(ProjectDetail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        project = _this$props.project,
        assignmentTerm = _this$props.assignmentTerm,
        expandedDesignAssignmentIds = _this$props.expandedDesignAssignmentIds,
        showArchivedAssignments = _this$props.showArchivedAssignments;
      var assignmentList = project.flows.assignmentList.filter(function (item) {
        return !item.archived;
      });
      var archivedAssignmentList = project.flows.assignmentList.filter(function (item) {
        return item.archived;
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "cccisd-design-area"
      }, /*#__PURE__*/_react["default"].createElement("div", null, assignmentList.length === 0 ? /*#__PURE__*/_react["default"].createElement("h3", {
        className: _style["default"].empty
      }, "Create a new ", assignmentTerm, " to begin...") : assignmentList.map(function (assignmentItem) {
        return /*#__PURE__*/_react["default"].createElement(_AssignmentCard["default"], {
          key: assignmentItem.assignmentId,
          isExpanded: expandedDesignAssignmentIds.includes(assignmentItem.assignmentId),
          project: project,
          assignmentData: assignmentItem,
          assignmentTerm: assignmentTerm,
          numActiveSurveys: assignmentList.length
        });
      }), archivedAssignmentList.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_HiddenBlock["default"], {
        label: "Archived Quests (".concat(archivedAssignmentList.length, ")"),
        show: showArchivedAssignments,
        toggle: this.props.toggleArchivedAssignments
      }, archivedAssignmentList.map(function (assignmentItem) {
        return /*#__PURE__*/_react["default"].createElement(_AssignmentCard["default"], {
          key: assignmentItem.assignmentId,
          isExpanded: expandedDesignAssignmentIds.includes(assignmentItem.assignmentId),
          project: project,
          assignmentData: assignmentItem,
          assignmentTerm: assignmentTerm,
          numActiveSurveys: assignmentList.length
        });
      })))));
    }
  }]);
  return ProjectDetail;
}(_react["default"].Component);
_defineProperty(ProjectDetail, "propTypes", {
  project: _propTypes["default"].object,
  assignmentTerm: _propTypes["default"].string,
  expandedDesignAssignmentIds: _propTypes["default"].array,
  showArchivedAssignments: _propTypes["default"].bool,
  toggleArchivedAssignments: _propTypes["default"].func
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    project: (0, _admin2.getFilteredCurrentProjectForDesign)(state.assignment.admin),
    expandedDesignAssignmentIds: state.assignment.admin.expandedDesignAssignmentIds,
    showArchivedAssignments: state.assignment.admin.showArchivedAssignments
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, {
  toggleArchivedAssignments: _admin.toggleArchivedAssignments
})(ProjectDetail);
exports["default"] = _default;